// /Declare a map to store the identity and cancellation functions for each request
import axios from 'axios';
const pending = new Map();
const pendingGetApi = new Map();

// Add request
const addPending = (config: any) => {
  const url = [
    config.method,
    config.url,
  ].join('&');
  const fuName = config.headers.common.fuName;
  config.cancelToken = config.cancelToken || new axios.CancelToken((cancel) => {
    if (!pending.has(url)) {// if the current request does not exist in pending, add it
      pending.set(url, cancel);
      // tslint:disable-next-line: no-unused-expression
      fuName && pendingGetApi.set(fuName, cancel);
    }
  });
};

// Remove request
const removePending = (config: any) => {
  const url = [
    config.method,
    config.url,
  ].join('&');
  if (pending.has(url)) {// if the current request ID exists in pending, you need to cancel the current request and remove it
    const cancel = pending.get(url);
    cancel(url);
    pending.delete(url);
  }
};

// Clear requests in pending (called on route jump)
const clearPending = () => {
  for (const [url, cancel] of pending as any) {
    cancel(url);
  }
  pending.clear();
};

const clearPendingGetApi = (fuName: string) => {
  if (pendingGetApi.has(fuName)) {
    const cancel = pendingGetApi.get(fuName);
    cancel(fuName);
    pendingGetApi.delete(fuName);
  }
};

export {
  addPending,
  removePending,
  clearPending,
  clearPendingGetApi,
};
